import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

/** Immediate feedback for every internal link while its route and data load. */
export function NavigationFeedback() {
  const location = useLocation();
  const [active, setActive] = useState(false);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    setActive(false);
    if (timeoutRef.current !== null) window.clearTimeout(timeoutRef.current);
  }, [location.key]);

  useEffect(() => {
    const handlePointerDown = (event: PointerEvent) => {
      if (event.button !== 0 || event.defaultPrevented) return;
      const target = event.target instanceof Element ? event.target : null;
      const link = target?.closest('a[href]');
      if (!link || link.getAttribute('target') === '_blank') return;
      const href = link.getAttribute('href') ?? '';
      if (!href.startsWith('/') || href.startsWith('//')) return;
      setActive(true);
      if (timeoutRef.current !== null) window.clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => setActive(false), 8_000);
    };
    document.addEventListener('pointerdown', handlePointerDown, true);
    return () => document.removeEventListener('pointerdown', handlePointerDown, true);
  }, []);

  return (
    <>
      <div
        aria-hidden="true"
        className={`pointer-events-none fixed inset-x-0 top-0 z-[100] h-0.5 origin-left bg-primary transition-transform duration-150 motion-reduce:transition-none motion-reduce:duration-0 ${active ? 'scale-x-100 opacity-100' : 'scale-x-0 opacity-0'}`}
      />
      <span className="sr-only" aria-live="polite">
        {active ? 'Opening…' : ''}
      </span>
    </>
  );
}
